import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'cta' | 'ghost' | 'outline';
  fullWidth?: boolean;
  iconLeft?: ReactNode;
}

const variants = {
  primary: 'bg-primary text-white hover:bg-blue-700 active:scale-[0.99] border border-primary/80 shadow-sm shadow-blue-600/20',
  cta: 'bg-cta text-white hover:bg-green-600 active:scale-[0.99] border border-cta/80 shadow-sm shadow-green-600/20',
  ghost: 'bg-transparent text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 border border-transparent',
  outline: 'bg-transparent text-slate-800 dark:text-slate-100 border border-borderLight dark:border-borderDark hover:bg-slate-100 dark:hover:bg-slate-800'
};

export default function Button({ children, variant = 'primary', fullWidth, className, iconLeft, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex h-11 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/45 disabled:cursor-not-allowed disabled:opacity-60 [&_svg]:shrink-0',
        variants[variant],
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {iconLeft ? <span className="ui-icon-inline">{iconLeft}</span> : null}
      {children}
    </button>
  );
}
